export default __webpack_public_path__ + "static/media/globalFlag.3a9b7395.png";